<header id="page-topbar" class="bay-topbar">

  <!-- ══ MOBILE header ══════════════════════════════════════════════════════ -->
  <div class="bay-topbar-mobile d-flex d-lg-none">

    <!-- Gauche : logo ferme + titre de la page -->
    <a routerLink="/dashboard" class="bay-mtop-brand text-decoration-none" aria-label="Accueil">
      <div class="bay-mtop-logo">
        <img *ngIf="ferme?.logoUrl" [src]="ferme?.logoUrl" alt="Logo">
        <img *ngIf="!ferme?.logoUrl" src="assets/images/wanar/wanar-signe.svg" alt="" class="bay-mtop-wanar">
      </div>
      <div class="bay-mtop-text">
        <span class="bay-mtop-farm">{{ ferme?.nom || 'Wanar' }}</span>
        <span class="bay-mtop-title">{{ pageTitle }}</span>
      </div>
    </a>

    <!-- Droite : notifications et profil -->
    <bay-notifications class="ms-auto me-1"></bay-notifications>
    <div class="dropdown flex-shrink-0" ngbDropdown placement="bottom-end">
      <button type="button" class="bay-profile-btn bay-profile-btn-mobile" ngbDropdownToggle aria-label="Mon compte">
        <div class="bay-avatar-circle bay-avatar-circle-sm">
          <img *ngIf="avatarUrl" [src]="avatarUrl" alt="Avatar" class="bay-avatar-img">
          <span *ngIf="!avatarUrl" class="material-symbols-outlined bay-avatar-icon">person</span>
        </div>
      </button>
      <div ngbDropdownMenu class="dropdown-menu-end border-0 shadow-lg rounded-3 p-2" style="min-width:220px">
        <div class="px-3 py-2 mb-1 border-bottom">
          <p class="fw-semibold text-dark mb-0 font-size-14 text-truncate">{{ onlineUser?.displayName || displayName }}</p>
          <p class="text-muted mb-0 font-size-12 text-truncate">{{ onlineUser?.email }}</p>
        </div>
        <a class="dropdown-item rounded-2 py-2 d-flex align-items-center gap-2" routerLink="/fermes">
          <span class="material-symbols-outlined font-size-16 text-muted">settings</span>
          Paramètres
        </a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item rounded-2 py-2 d-flex align-items-center gap-2 text-danger"
          href="javascript:void(0);" (click)="logout()">
          <span class="material-symbols-outlined font-size-16">logout</span>
          Déconnexion
        </a>
      </div>
    </div>

  </div>

  <!-- ══ DESKTOP header ═════════════════════════════════════════════════════ -->
  <div class="bay-topbar-desktop d-none d-lg-flex">

    <!-- Gauche : titre de la page -->
    <div class="bay-topbar-title">
      <p class="bay-page-label">{{ pageTitle }}</p>
      <h1 class="bay-page-greeting">Salaam<span *ngIf="displayName">, {{ displayName }}</span> 👋</h1>
    </div>

    <!-- Droite : actions -->
    <div class="d-flex align-items-center gap-2">

      <!-- Sélecteur de langue — masqué (pas encore fonctionnel) -->

      <bay-notifications></bay-notifications>

      <!-- Profil utilisateur -->
      <div class="dropdown" ngbDropdown>
        <button type="button" class="bay-profile-btn" ngbDropdownToggle>
          <div class="bay-avatar-circle bay-avatar-circle-sm">
            <img *ngIf="avatarUrl" [src]="avatarUrl" alt="Avatar" class="bay-avatar-img">
            <span *ngIf="!avatarUrl" class="material-symbols-outlined bay-avatar-icon">person</span>
          </div>
          <div class="d-none d-xl-block">
            <p class="bay-profile-name mb-0">{{ onlineUser?.displayName || displayName }}</p>
            <p class="bay-profile-email mb-0">{{ onlineUser?.email }}</p>
          </div>
          <span class="material-symbols-outlined bay-chevron d-none d-xl-inline">expand_more</span>
        </button>
        <div ngbDropdownMenu class="dropdown-menu-end border-0 shadow-lg rounded-3 p-2" style="min-width:200px">
          <div class="px-3 py-2 mb-1 border-bottom">
            <p class="fw-semibold text-dark mb-0 font-size-14">{{ onlineUser?.displayName || displayName }}</p>
            <p class="text-muted mb-0 font-size-12">{{ onlineUser?.email }}</p>
          </div>
          <a class="dropdown-item rounded-2 py-2 d-flex align-items-center gap-2" routerLink="/fermes">
            <span class="material-symbols-outlined font-size-16 text-muted">settings</span>
            Paramètres
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item rounded-2 py-2 d-flex align-items-center gap-2 text-danger"
            href="javascript:void(0);" (click)="logout()">
            <span class="material-symbols-outlined font-size-16">logout</span>
            Déconnexion
          </a>
        </div>
      </div>

    </div>
  </div>

</header>
